import { getProduct } from '#/products/domain';
import formatDecimal, {
  isValidDecimal,
  parseFormattedFloat,
} from '@paradigm/utils/formatDecimal';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import * as Quantity from '#/unified-rfqs/utils/quantity';

export interface QuantityView {
  value: string | undefined;
  precision: number;
  isVisible: boolean;
  isValid: boolean;
  isDisabled: boolean;
  contractQuantity: string;
}

export function quantityView(
  quantity: string | undefined,
  selectedProductCode: string,
  isOrderBook: boolean,
): QuantityView {
  const product = getProduct(selectedProductCode);

  if (quantity == null || !isValidDecimal(quantity)) {
    return {
      value: quantity,
      precision: product.quantityPrecision,
      isVisible: !isOrderBook,
      isValid: false,
      isDisabled: false,
      contractQuantity: NEGATIVE_SIGN,
    };
  }
  const numericValue = parseFormattedFloat(quantity);
  const isValid = numericValue > 0;

  const quantityFormatted = Quantity.normalize(
    selectedProductCode,
    numericValue,
  );

  return {
    value: quantityFormatted,
    precision: product.quantityPrecision,
    isValid,
    isDisabled: false,
    isVisible: !isOrderBook,
    contractQuantity: clearingUnitiesQuantity(
      quantityFormatted,
      selectedProductCode,
    ),
  };
}

export function clearingUnitiesQuantity(
  quantity: string,
  productCode: string,
): string {
  return `${formatDecimal(quantity)} ${
    getProduct(productCode).contractCurrency
  }`;
}
